var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.properties.component,_vm._g(_vm._b({tag:"component",scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("trigger")]},proxy:true}],null,true)},'component',_vm.props.properties.data,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }